export const STAT_CARD_VARIANTS = {
	default: {
		card: 'border border-gray-200',
		label: 'text-gray-500',
		value: '',
		description: 'text-gray-400',
	},
	green: {
		card: 'bg-[#5FBF77]',
		label: 'text-white',
		value: 'text-white',
		description: 'text-white/80',
	},
	bordered: {
		card: 'bg-white border border-gray-300',
		label: 'text-black',
		value: 'text-black',
		description: 'text-gray-600',
	},
	slate: {
		card: 'bg-[#9AA4A7]',
		label: 'text-gray-900',
		value: 'text-gray-900',
		description: 'text-gray-800',
	},
	dark: {
		card: 'bg-[#1E1E1E]',
		label: 'text-white',
		value: 'text-white',
		description: 'text-white/70',
	},
	ltgray: {
		card: 'bg-[#eeeeee]',
		label: 'text-black',
		value: 'text-black',
		description: 'text-gray-600',
	},
};

export default function StatCard({ label, value, description, valueClassName = '', variant = 'default' }) {
	const styles = STAT_CARD_VARIANTS[variant] || STAT_CARD_VARIANTS.default;
	return (
		<div className={`rounded-lg px-5 py-4 ${styles.card}`}>
			<p className={`text-xs mb-1 ${styles.label}`}>{label}</p>
			<p className={`text-2xl font-light ${styles.value} ${valueClassName}`}>{value ?? '-'}</p>
			{description && <p className={`text-xs mt-1 ${styles.description}`}>{description}</p>}
		</div>
	);
}
